module.exports = __webpack_public_path__ + "static/img/1_3_1.f3d7d0cd.jpg";